export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Staging detection function
export const isStaging = () => {
  return (
    process.env.REACT_APP_ENVIRONMENT === "staging" ||
    process.env.NODE_ENV === "development" ||
    window.location.hostname.includes("staging")
  );
};

// Collection names based on environment
export const COLLECTION_NAME = {
  users: isStaging() ? "staging-users" : "users",
  rides: isStaging() ? "staging-rides" : "Rides",
  scheduleRides: isStaging() ? "staging-scheduleRides" : "scheduleRides",
  rebookRides: "rebookRides",
  ridesHistory: isStaging() ? "Staging Rides History" : "Rides History",
  refundRequests: isStaging() ? "staging_refund_requests" : "refund_requests",
  surgePrice: "SurgePrice",
  payments: isStaging() ? "staging-payments" : "Payments",
  requestMoney: "Request Money",
};

export const RideStatus = Object.freeze({
  CANCEL_BEFORE_ACCEPTANCE: "cancel_before_acceptance",
  DRIVER_NOT_ASSIGNED: "driver_not_assigned",
  CANCEL_AFTER_ACCEPTANCE: "cancel_after_acceptance",
  DRIVER_ACCEPTED_NOT_ARRIVED: "driver_accepted_not_arrived",
  CANCEL_AFTER_ARRIVAL: "cancel_after_arrival",
  DRIVER_ARRIVED: "driver_arrived",
  DRIVER_CANCEL: "driver_cancel",
  DRIVER_NO_SHOW: "driver_no_show",
  SERVICE_ISSUE: "service_issue",
  MID_WAY_PASSENGER: "mid_way_passenger",
  PASSENGER_NO_SHOW: "passenger_no_show",
  MID_WAY_DRIVER: "mid_way_driver",
});

export const SEND_EMAIL = `${BASE_URL}sendMail`;
export const REFUND_REQUEST = `${BASE_URL}refund/ride-transaction`;
export const UPDATE_REFUND_REQUEST_STATUS = `${BASE_URL}refund/request/status`;
export const CANCEL_RIDE = `${BASE_URL}ride/cancelRide`;
export const FIREBASE_USER_DELETE = `${BASE_URL}firebase-user/:id`;
export const SEND_DEACTIVATION_NOTIFICATION = `${BASE_URL}notification/account-deactivated`;
export const SEND_REACTIVATION_NOTIFICATION = `${BASE_URL}notification/account-reactivated`;
export const SEND_RIDE_REASSIGNED_NOTIFICATION = `${BASE_URL}notification/ride-reassigned`;
export const SEND_NOTIFICATION = `${BASE_URL}sendNotification`;
export const UPDATE_USER = `${BASE_URL}updateUser`;
export const SEND_NOTIFICATION_BY_USER_ID = `${BASE_URL}sendNotificationByUserId`;
export const UPDATE_RIDE = `${BASE_URL}ride/updateRide`;

export const USER_TYPE = {
  PASSENGER: "passenger",
  DRIVER: "driver",
};

